import {emptyForm, handleApiForm} from "../../forms";
import {closeModal, openModal, pathIs} from "../../utilities";
import * as $ from "jquery";
import {toastAlert} from "../../toastAlert";
import {confirmModal} from "../../confirmModal";
import axios from "axios";
import {forestAddressesPage} from "./forest-addresses";

export const rsf_page = () => {
    const body = $('body');

    if(pathIs('/admin/regional-state-forests/*')) {
        forestAddressesPage()
    }

    handleApiForm('#addArea', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addAreaModal');

            let table = $('#areaTable').DataTable();

            let area = response.data.area;
            let row = $(`
                <tr data-id="${area.id}">
                    <td class="area__name">${area.name}</td>
                    <td>
                        <button data-id="${area.id}" type="button" class="btn btn-sm btn-primary btnEditArea">
                            Edytuj
                        </button>
                        <button data-id="${area.id}" type="button" class="btn btn-sm btn-danger btnDeleteArea">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            table.api().rows.add(row).draw(false);

            emptyForm(form);
            toastAlert('Pomyślnie dodano rejon');
        }
    })

    // Edit area
    body.on('click', '.btnEditArea', async function () {
        let id = $(this).data('id');
        let form = $("#editArea");

        let table = $('#areaTable').DataTable();
        let name = table.api().$(`tr[data-id="${id}"]`).find('.area__name').text();

        form.attr('action', window._EDIT_AREA_URL.replace('REPLACE_ID', id));
        form.find('[name="name"]').val(name);

        openModal('#editAreaModal')
    })

    // Edit area form
    handleApiForm('#editArea', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#editAreaModal');

            let table = $('#areaTable').DataTable();
            let area = response.data.area;

            let row = table.$(`tr[data-id="${area.id}"]`);
            let rowIndex = table.api().row(row).index();

            table.api().cell(rowIndex, 0).data(area.name);

            emptyForm(form);
            toastAlert('Pomyślnie edytowano rejon');
        }
    })

    // Delete area
    body.on('click', '.btnDeleteArea', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć wybrany rejon?', {color: 'danger'});
        if (!confirm) return;

        let id = $(this).data('id');

        try {
            const response = await axios.post(window._DELETE_AREA_URL.replace('REPLACE_ID', id));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let table = $('#areaTable').DataTable();
            let row = table.$(`tr[data-id=${$(this).data('id')}]`)
            table.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto rejon');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia rejonu', {type: 'danger'})
        }
    })
}
